
import {
  ActivimeterDetailDto,
  CreateActivimeterDetailDto,
  UpdateActivimeterDetailDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type ActivimeterDetailsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
}

class ActivimeterDetailService extends BaseCrudService<
  ActivimeterDetailDto,
  CreateActivimeterDetailDto,
  UpdateActivimeterDetailDto,
  ActivimeterDetailsFilters
> {
  constructor() {
    super('activimeter-detail', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const activimeterDetailService = new ActivimeterDetailService()
